module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "@bingads-webui/listener"
// module id = 2
// module chunks = 2 4 6 7